import React, {useCallback, useEffect, useMemo} from "react";
import Styles from "./styles.module.scss";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

import {getNotifications, readNotification} from "../../../store/cabinet/action";
import {notificationDateHandler, notificationViewHandler} from "../../../helpers/notifications";

const PER_PAGE = 10;
// за сколько пикселей до низа списка начинаем тянуть следующую страницу
const SCROLL_OFFSET = 80;

const CabinetMainNotifications = () => {
    const { t, i18n } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const notifications = useSelector(store => store.cabinet.notifications);
    const notificationsStarted = useSelector(store => store.cabinet.notificationsStarted);

    const lang = i18n.language ? i18n.language.slice(0, 2) : '';

    const list = useMemo(()=> notifications?.notifications || [], [notifications])
    const pagination = notifications?.pagination;
    const hasMore = pagination ? pagination.current_page < pagination.last_page : false;

    useEffect(()=>{
        dispatch(getNotifications({perPage: PER_PAGE}));
    },[dispatch])

    // подгрузка по прокрутке: следующая страница тянется, когда список
    // домотали почти до конца
    const scrollHandler = useCallback((e)=>{
        if (notificationsStarted || !hasMore){
            return;
        }

        const el = e.target;
        if (el.scrollHeight - el.scrollTop - el.clientHeight > SCROLL_OFFSET){
            return;
        }

        dispatch(getNotifications({page: pagination.current_page + 1, perPage: PER_PAGE, append: true}));
    },[dispatch, notificationsStarted, hasMore, pagination])

    const readHandler = useCallback((item)=>{
        if (item?.read){
            return;
        }
        dispatch(readNotification(item?.id));
    },[dispatch])

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap} ${Styles.cabinetPC}`}>
                <div className={`${Styles.cardWrap} ${Styles.border3dOuterXl}`}>
                    <div className={`${Styles.cardHead}`}>
                        <div className={`${Styles.cardTitle}`}>
                            {t('Уведомления')}
                            {notifications?.unread_count ? (
                                <span className={`${Styles.unreadCount}`}>{notifications.unread_count}</span>
                            ) : null}
                        </div>
                        <div
                            className={`${Styles.cardChip}`}
                            onClick={()=>{navigate('/cabinet/events')}}
                        >
                            {t('Смотреть все')}
                        </div>
                    </div>

                    <div className={`${Styles.updatesWrap}`} onScroll={scrollHandler}>
                        {list.length ? list.map((item, index)=>{
                            const date = notificationDateHandler(item?.created_at, lang);
                            const view = notificationViewHandler(item, t, lang);

                            return (
                                <React.Fragment key={'cabinet-notification_' + item?.id}>
                                    {index ? <div className={`${Styles.updateDivider}`}/> : null}
                                    <div
                                        className={`${Styles.updateRow} ${item?.read ? '' : Styles.updateRowNew}`}
                                        onClick={()=>{readHandler(item)}}
                                    >
                                        <div className={`${Styles.updateDate}`}>
                                            <span className={`${Styles.updateDay}`}>{date.day}</span>
                                            <span className={`${Styles.updateMonth}`}>{date.month}</span>
                                        </div>
                                        <div className={`${Styles.updatePos}`}>
                                            <div className={`${Styles.updateTitle}`}>
                                                {view.title}
                                                {item?.read ? null : <span className={`${Styles.updateDot}`}/>}
                                            </div>
                                            {view.text ? (
                                                <div className={`${Styles.updateNote}`}>{view.text}</div>
                                            ) : null}
                                        </div>
                                        {view.amount ? (
                                            <div className={`${Styles.updateAmount} ${view.amountSign === 'minus' ? Styles.updateAmountMinus : ''}`}>
                                                {view.amountSign === 'minus' ? '−' : '+'}{view.amount}
                                            </div>
                                        ) : null}
                                    </div>
                                </React.Fragment>
                            );
                        }) : (
                            <div className={`${Styles.emptyNote}`}>
                                {notificationsStarted ? t('Загружаем…') : t('Уведомлений пока нет')}
                            </div>
                        )}

                        {list.length && notificationsStarted ? (
                            <div className={`${Styles.loadingNote}`}>{t('Загружаем…')}</div>
                        ) : null}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CabinetMainNotifications;
